import React, {useState} from "react";
import {Typography} from "@mui/material";
import Privacy from "./Privacy.jsx";
import Home from "./Home.jsx";
import {Route, Routes} from "react-router-dom";
import Terms from "./Terms.jsx";
import ReactGA from "react-ga4";

const Section = ({id, bg = "light", title, subtitle, children}) => (
    <section id={id} className={`py-5 bg-${bg}`}>
        <div className="container">
            <Typography variant="h4" className="mb-4 text-center">{title}</Typography>
            <Typography variant="h5" className="mb-4 text-center">{subtitle}</Typography>
            {children}
        </div>
    </section>
);

const App = () => {

    ReactGA.initialize("G-DEG2BNSW28");

    const [showNav, setShowNav ] = useState(false);
    const toggleNav =()=> {
        setShowNav(!showNav);
    }

    return (
        <>
            <div>
                {/* Navbar */}
                <nav className="navbar navbar-expand-lg navbar-dark shadow-sm" style={{
                    borderBottom: 'solid 10px #111',
                    background: 'linear-gradient(195deg, rgb(91, 150, 169), rgb(25, 25, 25))'
                }}>
                    <div className="container">

                        <a className="navbar-brand fw-bold" href="#">
                            <img alt={'Play Space Brain Header Logo - Big 2026!'}
                                 src={'https://playspacebrain.com/images/psb-logo-round-sm-2026.png'} style={{
                                width: '40px',
                                height: 'auto'
                            }}/>
                            &nbsp;<span style={{
                            fontStyle: "italic",
                            fontSize: '0.9rem'
                        }}></span>
                        </a>
                        <button onClick={()=>{
                            toggleNav()
                        }} className="navbar-toggler" type="button" data-bs-toggle="collapse"
                                data-bs-target="#navbarNav">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className={!showNav ? 'collapse navbar-collapse' : 'navbar-collapse'}  id="navbarNav">
                            <ul className="navbar-nav ms-auto">
                                {[{
                                    id: 'header',
                                    name: '/'
                                }, {
                                    id: 'inside',
                                    name: 'Manage Your Play Space'
                                }, {
                                    id: 'explore',
                                    name: 'Explore Tools'
                                }, {
                                    id: 'features',
                                    name: 'List of Features'
                                }, {
                                    id: 'pricing',
                                    name: 'Our Pricing'
                                }, {
                                    id: 'contact',
                                    name: 'Get Started'
                                }].map((section, idx) => (
                                    <li className="nav-item" key={idx} onClick={()=>{
                                        setShowNav(false);
                                    }}>
                                        <a className="nav-link text-white px-3"
                                           href={`/#${section.id}`}>{section.name}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </nav>
                <Routes>
                    <Route exact path="/" element={<Home/>}/>
                    <Route exact path="/privacy" element={<Privacy/>}/>
                    <Route exact path="/terms" element={<Terms/>}/>
                    <Route path="*" element={<Home/>}/>
                </Routes>

            </div>

            {/* Footer */}
            <footer className="text-white py-4 mt-5 text-right" style={{
                background: '#222',
                display: 'block',
                width: '100%'
            }}>
                <div className="container" style={{
                    display: 'block',
                    width: '100%'
                }}>
                    <span className='text-left mx-2' style={{
                        float: 'left'
                    }}><small>&copy; {new Date().getFullYear()} Play Space Brain, LLC</small>
                    </span>

                    <small>
                        <a className='text-right mx-2' href={'/'}>/</a>
                        <a className='text-right mx-2' href={'/privacy'}>Privacy</a>
                        <a className='text-right mx-2' href={'/terms'}>Terms</a>
                    </small>
                </div>
            </footer>

        </>
    );
};

export default App;
